<template>
    <v-layout class="error-message" column>
        <div class="oops">{{$t('common.login.oops')}}</div>
        <div class="something-went-wrong">{{$t('common.login.something_went_wrong')}}</div>
    </v-layout>
</template>

<script>

    export default {
        name: 'LoginServerError',
    }
</script>


<style scoped lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_i18n-mixins.scss";

    .error-message{
        color: #333333;
        text-align: center;
        margin: 27px auto 7px auto;
        width: 100%;

        .oops{
            font-size: 22px;
            font-weight: 600;
            font-family: var(--font2);
        }

        .something-went-wrong{
            margin-top: 5px;
            font-size: 15px;
            font-family: var(--font3);
        }
    }



</style>
